import * as React from 'react';
import { Props as BaseProps } from '../Base/Base';
import Flex from '../Flex/Flex';
import PlacementArea from '../Placement/PlacementArea';
import './DropdownMenu.css';

export interface Props extends BaseProps {
  /** The height the DropdownMenu can go to before it starts to scroll */
  maxHeight?: string;
  /** Fixed width of the menu and all of the DropdownMenuItems */
  width?: number | string;
}

/**
 * Parent container for DropdownMenuItems
 */
const DropdownMenu: React.FunctionComponent<Props> = (props: Props) => {
  const {
    children,
    maxHeight,
    width,
    ...rest
  } = props;

  return (
    <PlacementArea { ...rest }
        direction="vertical"
        paddingVertical="x4">
      <Flex
          className="DropdownMenu__content"
          direction="vertical"
          maxHeight={ maxHeight }
          width={ width }>
        { children }
      </Flex>
    </PlacementArea>
  );
};
DropdownMenu.defaultProps = {
  width: '16rem',
};

export default DropdownMenu;
